export default __webpack_public_path__ + "./images/wink.d4527928.svg";